<template>
  <div class="seventhPage" :style="{height:screenHeight}" style="position: relative">
    <span class="seventhTitle" :class="activeShow===7?'animate__animated animate__bounceInUp':''">365头条 — 方寸之间 精彩万千</span>
    <span class="seventhSubtitle" :class="activeShow===7?'animate__animated animate__bounceInUp':''">前沿最新媒体资讯 一站式实时资源共享</span>
    <div style="width:90%;margin-left:5%;">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/seventhBanner.png" class="seventhImg width100 margin-top-15" :class="activeShow===7?'animate__animated animate__bounceInDown':''">
      <div class="svthTabs">
        <van-tabs v-model="active" style="width:100%;float:left;" background="#000" color="#ff943c" title-inactive-color="#fff" title-active-color="#fff" :swipeable="true" line-width="70" :class="activeShow===7?'animate__animated animate__backInRight':''" :ellipsis="false">
          <van-tab title="媒体报道">
            <ul>
              <li class="svthNewsTitle" @click="godetail1(1)">>>365跑腿网总部，打造即时、共享生活服务平台</li>
              <li class="svthNewsTitle" @click="godetail1(3)">>>别样的中秋：一笔特殊的”跑腿“订单</li>
              <li class="svthNewsTitle" @click="godetail1(2)">>>把帮小忙做成大产业</li>
              <!-- <li class="svthNewsTitle">>>发布春节期间关爱活动</li>
              <li class="svthNewsTitle">>>发布春节期间关爱活动，春节将</li>
              <li class="svthNewsTitle">>>发布春节期间关爱活动，春节将至，全国</li>
              <li class="svthNewsTitle">>>发布春节期间关爱活动，春节将至</li> -->
            </ul>
          </van-tab>
          <van-tab title="身边故事">
            <ul>
              <li class="svthNewsTitle" @click="godetail1(20220225)">>>代表白、结婚登记代排队，365跑腿定制化服务为爱助力</li>
              <li class="svthNewsTitle" @click="godetail1(20211227)">>>365跑腿：打造温暖企业 传递温馨和谐</li>
              <li class="svthNewsTitle" @click="godetail1(20211222)">>>365跑腿提供品质同城生活配送服务，打造青岛人便捷生活新方式</li>
            </ul>
          </van-tab>
          <van-tab title="行业资讯">
            <ul>
              <li class="svthNewsTitle" @click="godetail1(20211201)">>>365跑腿进驻胶南，跑腿骑士热情招募中！</li>
              <li class="svthNewsTitle" @click="godetail1(20211125)">>>365云商上线，智慧同城，美好启航</li>
              <li class="svthNewsTitle" @click="godetail1(9)">>>前英特尔、英伟达、苹果全球副总裁考察众业网科</li>
            </ul>
          </van-tab>
        </van-tabs>
        <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/orange_arrow.png" class="orange_arrow" :class="activeShow===7?'animate__animated animate__backInLeft':''">
        <span class="svthMore" :class="activeShow===7?'animate__animated animate__backInLeft':''">more</span>
      </div>
    </div>
    <div class="line100"></div>
    <div class="width100 text-center float-left">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down_arrow.png" class="downButton" @click="moveSectionDown">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'fifthPage',
    data(){
      return {
        screenHeight:0,
        screenWidth:0,
        form:{
          companyName:""
        },
        active:0
      }
    },
    props: {
      activeShow: Number
    },
    mounted(){

    },
    created(){
      this.screenHeight = document.documentElement.clientHeight+'px';
      this.screenWidth = document.documentElement.clientWidth+'px';
    },
    methods:{
      // 翻页方法 子传父
      moveSectionDown(){
        this.$emit('moveSectionDown');
      },
      godetail1(e){
        this.$router.push({
          path: '/page?id='+e
        })
      },
    }
  }
</script>
<style lang="less">
  .seventhPage{width:100%;float:left;}
  .seventhTitle,.seventhSubtitle{color:#fff;width:100%;float:left;text-align: center}
  .seventhTitle{font-size:1.5em;padding-top:20%;font-weight: 300;}
  .seventhSubtitle{margin-top:1.3%;font-size:0.8em;font-weight: 200;}
  .svthTabs {
    width:100%;
    float:left;
    position: relative;
    .van-tab__text {
      font-size:1.3em;
      font-weight: 400;
    }
    .van-tab--active .van-tab__text{font-weight: bold;}
    .van-tabs__nav{width:80%}
    .van-tabs__wrap{border-bottom: 2px solid #CCC}
    .svthMore{color:#ff943c;position: absolute;right:0;top:13px;}
    ul{float:left;width:100%;margin-top:2%}
    .svthNewsTitle{color:#fff;line-height: 5.2vh;font-size:1em;font-weight: 150;}
    .orange_arrow{float:right;margin-top:2%;}
  }
</style>
